import React, { useState, useEffect } from "react";
import { cilGroup, cilReload, cilSearch, cilSpeech } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CButton, CCol, CFormInput, CRow } from "@coreui/react";
import { Link, useNavigate } from "react-router-dom";
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CTableCaption,
} from "@coreui/react";
import adminAxiosInstance from "../../../config";
import ReactPaginate from "react-paginate";
import "./scss/admin-contact.scss";
import err404 from "../../../errors/svg/noData.jpg";
import err500 from "../../../errors/svg/err500.svg";
import moment from "moment";

import bckSvg from "../../../User/assets/svg/backArrow.svg";
import frtSvg from "../../../User/assets/svg/frontArrow.svg";
import { liveLink } from "../../../config/baseUrl";

const UserInquiries = () => {
  const [data, setData] = useState();
  const [datasearch, setDataSearch] = useState([]);

  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchData, setSearchData] = useState("");
  const [error, setError] = useState(200);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const adminToken = localStorage.getItem("token");


  let limit = 10;
  let totalCount;
  const navigate = useNavigate();

  const fetchData = async (currentPage, searchData) => {
    setLoading(true);
    try {
      const response = await adminAxiosInstance.get(
        `/inquiryNow/getAll?page=${currentPage}&type=user&limit=${limit}&startDate=${
          fromDate ? fromDate : ""
        }&endDate=${toDate ? toDate : ""}&str=${searchData ? searchData : ""}`,
        {
          headers: { Authorization: `Bearer ${adminToken}` },
        }
      );
      response?.data?.data.result?.forEach((element) => {
        element.momentDate = moment(element.createdAt).format(
          "DD-MM-YYYY h:mm:ss"
        );
      });
      if (response.status === 200) {
        // console.log(response.data.data);
        totalCount = parseInt(response?.data?.data?.total_count);
        setPageCount(Math.ceil(totalCount / limit));
        setData(response?.data?.data);
        setError(200);
      }
      setLoading(false);
    } catch (error) {
      if (error.response.status === 404) {
        setError(404);
        setLoading(false);
        setData();
      } else {
        setError(500);
        setLoading(false);
        setData();
      }
    }
  };

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    document.getElementById("datez").value = "";
    document.getElementById("dates").value = "";
  };

  const handlePageClick = (data) => {
    // console.log(data.selected);
    setCurrentPage(data.selected + 1);
    // console.log(currentPage);
  };
  const pageData = async (currentPage) => {
    fetchData(currentPage, searchData);
  };

  const handlesubmit = () => {
    // setSearchData(datasearch)
    if(searchData){

      fetchData(1, searchData);
    }
  }

  useEffect(() => {
    pageData(currentPage);
    fetchData(currentPage, searchData);

  }, [currentPage]);

  useEffect(() => {
    fetchData(1, searchData);
  }, [fromDate, toDate]);

  // useEffect(() => {
  // }, [searchData]);

  useEffect(() => {
    searchData.length == 0 &&
    fetchData(1, "");
  }, [searchData]);

  return (
    <>
      <CRow>
        <div className="d-flex">
          <CIcon icon={cilGroup} size="xxl" />
          <h3>User Inquiries</h3>
        </div>
        <CCol sm={12} className="mt-3">
          <h5>Export Data</h5>
        </CCol>
        <div className="admin-topp">
          {/* <CCol lg={2} md={6} sm={5} className="mb-3"> */}
          <input
            onChange={(e) => setFromDate(e.target.value)}
            placeholdertext="dd/mm/yy"
            dateformat="dd/MM/yyyy"
            max={toDate}
            type="date"
            className="sellDate admin-sellDate"
            id="datez"
          />
          {/* </CCol> */}
          {/* <CCol lg={2} md={6} sm={5} className="mb-3"> */}
          <input
            onChange={(e) => setToDate(e.target.value)}
            placeholdertext="dd/mm/yy"
            dateformat="dd/MM/yyyy"
            min={fromDate}
            type="date"
            className="sellDate admin-sellDate"
            id="dates"
          />
          {/* </CCol> */}
          {/* <CCol lg={1} className=" mb-3"> */}
          <CButton
            color="info"
            className={`text-white reload-sell-btn admin-btn`}
          >
            <CIcon icon={cilReload} onClick={() => handleReset()} />
          </CButton>
          {data ? (
            <>
              {" "}
              <a
                target="_blank"
                href={
                  fromDate && toDate
                    ? `${liveLink}/v1/admin/contactUs/exportData?startDate=${fromDate}&endDate=${toDate}`
                    : searchData
                    ? `${liveLink}/v1/admin/contactUs/exportData?str=${searchData}`
                    : `${liveLink}/v1/admin/contactUs/exportData`
                }
                rel="noreferrer nofollow"
                download
              >
                <CButton color="info" className={`text-white`}>
                  Export Data
                </CButton>
              </a>
            </>
          ) : (
            <>
              {" "}
              <CButton color="info" className={`text-white`} disabled>
                Export Data
              </CButton>
            </>
          )}
          {/* </CCol> */}
        </div>
        <CCol sm={12} className="mt-4">
          <h5>Search Data</h5>
        </CCol>

        <div className="admin-topp">
          <CCol lg={3} md={4} sm={5}>
            <CFormInput
              type="search"
              id="exampleFormControlInput1"
              placeholder="Search Text"
              // value={searchData}
              // onChange={(e) => {
              //   setSearchData(e.target.value);
              // }}
              onChange={(e) => setSearchData(e.target.value)}
               // onChange={(e) => handlesearchdata(e.target.value)}
            />
          </CCol>
          <CButton className="me-2" color="dark" onClick={handlesubmit}>
              Search
            </CButton>
        </div>
      </CRow>
      {loading ? (
        <div className="loader-content">
          <div className="spinner-border text-secondary"></div>
        </div>
      ) : (
        <>
          <div className="bg-white mt-3 ps-3 pe-3 pb-1 mb-3">
            <CTable caption="top" responsive>
              {error === 200 ? (
                <>
                  <CTableCaption className="fs-3 text-dark">
                    User Inquiry List
                  </CTableCaption>
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell scope="col">Sr.No.</CTableHeaderCell>
                      <CTableHeaderCell scope="col" className="cc-name">
                        User Name
                      </CTableHeaderCell>
                      <CTableHeaderCell scope="col" className="cc-name">
                        User Code
                      </CTableHeaderCell>
                      <CTableHeaderCell scope="col">Mobile</CTableHeaderCell>
                      <CTableHeaderCell scope="col" className="cc-name">
                        Company ID
                      </CTableHeaderCell>
                      <CTableHeaderCell scope="col" className="cc-name">
                        Company Name
                      </CTableHeaderCell>
                      <CTableHeaderCell scope="col" className="cc-date">
                        Date
                      </CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {data &&
                      data?.result?.map((item, index) => (
                        <CTableRow key={index}>
                          <CTableHeaderCell scope="row">
                            {item?.index}
                          </CTableHeaderCell>
                          <CTableDataCell>{item?.userName}</CTableDataCell>
                          <CTableDataCell>
                            {item?.userUniqueCode}
                          </CTableDataCell>
                          <CTableDataCell>{item?.userMobile}</CTableDataCell>
                          <CTableDataCell>{item?.companyId}</CTableDataCell>
                          <CTableDataCell>{item?.companyName}</CTableDataCell>
                          <CTableDataCell>{item?.momentDate}</CTableDataCell>
                        </CTableRow>
                      ))}
                    {/* <CTableRow>
                      <CTableHeaderCell colSpan="12" scope="row">
                        Total Results : {data?.result?.length}
                      </CTableHeaderCell>
                    </CTableRow> */}
                  </CTableBody>
                </>
              ) : error === 404 ? (
                <CTableBody>
                  <CTableRow>
                    <CTableDataCell className="d-flex justify-content-center">
                      <img
                        src={err404}
                        alt=""
                        style={{ height: "400px", width: "400px" }}
                      />
                    </CTableDataCell>
                  </CTableRow>
                </CTableBody>
              ) : (
                <CTableBody>
                  <CTableRow>
                    <CTableDataCell className="d-flex justify-content-center">
                      <img
                        src={err500}
                        alt=""
                        style={{ height: "400px", width: "400px" }}
                      />
                    </CTableDataCell>
                  </CTableRow>
                </CTableBody>
              )}
            </CTable>
          </div>
        </>
      )}

      {error === 200 ? (
        pageCount && pageCount > 1 ? (
          <>
            <div className="myPaginationBottom">
              <span>Total Results : {data?.result?.length}</span>
              <ReactPaginate
                previousLabel={
                  <>
                    <img src={bckSvg} alt="backButton" />
                  </>
                }
                nextLabel={
                  <>
                    <img src={frtSvg} alt="frtButton" />
                  </>
                }
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </div>
          </>
        ) : (
          ""
        )
      ) : (
        ""
      )}
    </>
  );
};

export default UserInquiries;
